import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';

const OutboundView = () => import('./OutboundView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/outbound'),
    name: 'outbound_dashboard',
    meta: {
      featureFlag: FEATURE_FLAGS.OUTBOUND,
      permissions: ['administrator', 'agent'],
    },
    component: OutboundView,
  },
];
